var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"text-body-2",attrs:{"color":"primary"}},[_vm._v(" Desenvolvido por: André Oliveira | Hogrefe ® Todos os direitos reservados 2023 ")])}
var staticRenderFns = []

export { render, staticRenderFns }